var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 646,
    viewBox: "0 0 646 646",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.438 383.562H383.562V489.547H262.438V383.562Z",
    fill: "url(#paint0_linear_893_5460)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.438 444.119C276.251 458.826 298.235 469.354 323 469.354C348.33 469.354 369.82 459.401 383.562 444.119V635.905H262.438V444.119Z",
    fill: "url(#paint1_linear_893_5460)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.438 444.119C276.251 458.826 298.235 469.354 323 469.354C348.33 469.354 369.82 459.401 383.563 444.119C389.155 445.356 396.074 447.026 403.876 449.04C392.137 472.614 360.408 489.541 323 489.541C285.593 489.541 253.863 472.614 242.124 449.04C249.926 447.026 256.846 445.361 262.438 444.119Z",
    fill: "url(#paint2_linear_893_5460)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.641 499.636L85.7969 489.547C85.7969 489.547 35.3281 540.016 10.0938 635.906H176.641V499.636Z",
    fill: "url(#paint3_linear_893_5460)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.25 439.078C206.271 447.047 115.629 467.669 85.7969 489.547L136.266 635.906H302.812L242.25 439.078Z",
    fill: "url(#paint4_linear_893_5460)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M469.359 499.636L560.203 489.547C560.203 489.547 610.672 540.016 635.906 635.906H469.359V499.636Z",
    fill: "url(#paint5_linear_893_5460)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M403.75 439.078C439.729 447.047 530.371 467.669 560.203 489.547L509.734 635.906H343.188L403.75 439.078Z",
    fill: "url(#paint6_linear_893_5460)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M504.688 266.763C504.688 289.06 488.871 312.906 469.359 312.906C449.848 312.906 434.031 289.06 434.031 266.763C434.031 244.466 449.848 232.156 469.359 232.156C488.871 232.156 504.688 244.466 504.688 266.763Z",
    fill: "url(#paint7_linear_893_5460)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.922 266.763C206.922 289.06 191.105 312.906 171.594 312.906C152.083 312.906 136.266 289.06 136.266 266.763C136.266 244.466 152.083 232.156 171.594 232.156C191.105 232.156 206.922 244.466 206.922 266.763Z",
    fill: "url(#paint8_linear_893_5460)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M449.172 141.312H196.828C185.533 144.053 176.641 154.924 176.641 166.547V267.52C176.641 353.281 242.25 418.891 323 418.891C403.75 418.891 469.359 353.281 469.359 267.52V166.547C469.359 154.889 460.512 144.023 449.172 141.312Z",
    fill: "url(#paint9_linear_893_5460)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M323 10.0938C402.16 10.0938 489.547 71.6051 489.547 166.547C489.284 226.665 469.359 267.484 469.359 267.484C469.359 237.203 454.219 166.547 454.219 166.547C368.422 186.734 196.828 146.359 196.828 146.359C196.828 146.359 176.641 176.641 176.641 267.484C176.641 267.484 146.359 232.156 146.359 171.594C146.359 96.0723 181.688 80.75 181.688 80.75C181.688 80.75 191.781 10.0938 323 10.0938Z",
    fill: "url(#paint10_linear_893_5460)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.909 383.562C311.503 383.562 300.127 379.888 289.791 372.549C288.7 371.774 287.961 370.596 287.738 369.276C287.514 367.956 287.825 366.601 288.6 365.509C289.376 364.417 290.554 363.679 291.874 363.455C293.194 363.232 294.549 363.542 295.641 364.318C312.916 376.597 332.866 376.592 350.384 364.303C350.927 363.92 351.539 363.648 352.187 363.502C352.835 363.356 353.505 363.34 354.159 363.453C354.813 363.567 355.438 363.809 355.999 364.164C356.559 364.52 357.044 364.983 357.426 365.526C357.807 366.07 358.078 366.683 358.222 367.331C358.366 367.979 358.38 368.65 358.265 369.303C358.149 369.957 357.906 370.582 357.549 371.141C357.192 371.701 356.727 372.185 356.183 372.565C345.731 379.893 334.305 383.562 322.909 383.562Z",
    fill: "url(#paint11_linear_893_5460)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257.391 287.672C265.753 287.672 272.531 280.893 272.531 272.531C272.531 264.169 265.753 257.391 257.391 257.391C249.029 257.391 242.25 264.169 242.25 272.531C242.25 280.893 249.029 287.672 257.391 287.672Z",
    fill: "url(#paint12_linear_893_5460)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M388.609 287.672C396.971 287.672 403.75 280.893 403.75 272.531C403.75 264.169 396.971 257.391 388.609 257.391C380.247 257.391 373.469 264.169 373.469 272.531C373.469 280.893 380.247 287.672 388.609 287.672Z",
    fill: "url(#paint13_linear_893_5460)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M287.667 232.126C286.725 232.126 285.802 231.862 285.002 231.364C256.946 213.897 238.672 225.646 230.869 230.668L229.809 231.349C228.679 232.005 227.339 232.198 226.07 231.886C224.801 231.575 223.702 230.784 223.003 229.679C222.305 228.575 222.062 227.243 222.325 225.963C222.588 224.683 223.337 223.555 224.414 222.815L225.413 222.179C234.013 216.643 256.876 201.956 290.341 222.8C291.271 223.381 291.986 224.248 292.378 225.271C292.771 226.294 292.82 227.418 292.518 228.471C292.216 229.524 291.579 230.451 290.704 231.11C289.829 231.77 288.763 232.127 287.667 232.126Z",
    fill: "url(#paint14_linear_893_5460)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M358.333 232.126C357.237 232.126 356.171 231.769 355.296 231.109C354.421 230.45 353.784 229.523 353.482 228.47C353.18 227.417 353.229 226.294 353.621 225.27C354.014 224.247 354.729 223.38 355.658 222.799C389.129 201.945 411.986 216.647 420.591 222.178L421.585 222.814C422.663 223.554 423.412 224.682 423.675 225.962C423.938 227.242 423.694 228.574 422.996 229.678C422.298 230.783 421.199 231.574 419.93 231.885C418.661 232.197 417.321 232.004 416.19 231.348L415.131 230.672C407.333 225.656 389.048 213.901 360.993 231.369C360.165 231.878 359.247 232.126 358.333 232.126Z",
    fill: "url(#paint15_linear_893_5460)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M322.98 338.141H322.955C318.034 338.13 313.285 335.834 309.223 331.499C308.362 330.513 307.917 329.231 307.983 327.924C308.049 326.616 308.619 325.385 309.574 324.49C310.529 323.595 311.795 323.106 313.104 323.125C314.413 323.145 315.663 323.672 316.591 324.595C318.065 326.164 320.366 328.042 322.97 328.047H322.98C325.605 328.047 327.931 326.164 329.425 324.58C329.88 324.097 330.426 323.71 331.03 323.438C331.635 323.167 332.288 323.017 332.95 322.998C333.613 322.979 334.273 323.09 334.893 323.326C335.512 323.562 336.079 323.918 336.561 324.373C337.044 324.828 337.431 325.373 337.703 325.978C337.974 326.583 338.124 327.235 338.143 327.898C338.162 328.561 338.051 329.221 337.815 329.84C337.579 330.46 337.223 331.027 336.768 331.509C332.67 335.849 327.906 338.141 322.98 338.141Z",
    fill: "url(#paint16_linear_893_5460)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.438 423.938L302.812 635.906L222.062 560.203L232.156 519.828L196.828 514.776L237.203 439.073C241.301 431.659 252.975 423.943 262.438 423.938Z",
    fill: "url(#paint17_linear_893_5460)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M383.562 423.938L343.188 635.906L423.938 560.203L413.844 519.828L449.172 514.776L408.797 439.073C404.699 431.659 393.025 423.943 383.562 423.938Z",
    fill: "url(#paint18_linear_893_5460)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M237.203 600.578H211.969C210.63 600.578 209.347 600.046 208.4 599.1C207.454 598.153 206.922 596.87 206.922 595.531C206.922 594.193 207.454 592.909 208.4 591.963C209.347 591.016 210.63 590.484 211.969 590.484H237.203C242.77 590.484 247.297 585.957 247.297 580.391V529.922C247.297 504.874 226.918 484.5 201.875 484.5C176.832 484.5 156.453 504.874 156.453 529.922V580.391C156.453 585.957 160.98 590.484 166.547 590.484H186.734C188.073 590.484 189.357 591.016 190.303 591.963C191.25 592.909 191.781 594.193 191.781 595.531C191.781 596.87 191.25 598.153 190.303 599.1C189.357 600.046 188.073 600.578 186.734 600.578H166.547C155.413 600.578 146.359 591.524 146.359 580.391V529.922C146.359 499.313 171.266 474.406 201.875 474.406C232.484 474.406 257.391 499.313 257.391 529.922V580.391C257.391 591.524 248.337 600.578 237.203 600.578Z",
    fill: "url(#paint19_linear_893_5460)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M201.875 474.406C171.266 474.406 146.359 499.313 146.359 529.922H156.453C156.453 504.874 176.832 484.5 201.875 484.5C226.918 484.5 247.297 504.874 247.297 529.922H257.391C257.391 499.313 232.484 474.406 201.875 474.406Z",
    fill: "url(#paint20_linear_893_5460)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186.734 590.484H176.641V600.578H186.734C188.073 600.578 189.357 600.046 190.303 599.1C191.25 598.153 191.781 596.87 191.781 595.531C191.781 594.193 191.25 592.909 190.303 591.963C189.357 591.016 188.073 590.484 186.734 590.484Z",
    fill: "url(#paint21_linear_893_5460)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M211.969 590.484H222.062V600.578H211.969C210.63 600.578 209.347 600.046 208.4 599.1C207.454 598.153 206.922 596.87 206.922 595.531C206.922 594.193 207.454 592.909 208.4 591.963C209.347 591.016 210.63 590.484 211.969 590.484Z",
    fill: "url(#paint22_linear_893_5460)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M403.664 394.342C398.496 397.822 393.108 400.964 387.534 403.749H393.656C432.618 403.749 464.312 435.444 464.312 474.405V534.968C464.312 536.306 464.844 537.59 465.79 538.537C466.737 539.483 468.021 540.015 469.359 540.015C470.698 540.015 471.981 539.483 472.928 538.537C473.874 537.59 474.406 536.306 474.406 534.968V474.405C474.406 433.278 443.474 399.298 403.664 394.342Z",
    fill: "url(#paint23_linear_893_5460)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242.659 394.561C216.657 399.158 196.828 421.869 196.828 449.173V479.454C196.828 480.793 197.36 482.076 198.306 483.023C199.253 483.969 200.536 484.501 201.875 484.501C203.214 484.501 204.497 483.969 205.444 483.023C206.39 482.076 206.922 480.793 206.922 479.454V449.173C206.922 424.125 227.301 403.751 252.344 403.751C253.627 403.746 254.86 403.247 255.786 402.358C251.276 399.992 246.894 397.389 242.659 394.561Z",
    fill: "url(#paint24_linear_893_5460)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M469.359 580.391C483.296 580.391 494.594 569.093 494.594 555.156C494.594 541.22 483.296 529.922 469.359 529.922C455.423 529.922 444.125 541.22 444.125 555.156C444.125 569.093 455.423 580.391 469.359 580.391Z",
    fill: "url(#paint25_linear_893_5460)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M469.359 580.391C483.296 580.391 494.594 569.093 494.594 555.156C494.594 541.22 483.296 529.922 469.359 529.922C455.423 529.922 444.125 541.22 444.125 555.156C444.125 569.093 455.423 580.391 469.359 580.391Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_893_5460",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 444,
    y: 529,
    width: 51,
    height: 52
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M469.359 580.391C483.296 580.391 494.594 569.093 494.594 555.156C494.594 541.22 483.296 529.922 469.359 529.922C455.423 529.922 444.125 541.22 444.125 555.156C444.125 569.093 455.423 580.391 469.359 580.391Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_893_5460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.125 529.922H494.594V580.391H444.125V529.922Z",
    fill: "url(#paint26_linear_893_5460)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M469.359 585.438C452.659 585.438 439.078 571.856 439.078 555.156C439.078 538.456 452.659 524.875 469.359 524.875C486.059 524.875 499.641 538.456 499.641 555.156C499.641 571.856 486.059 585.438 469.359 585.438ZM469.359 534.969C458.226 534.969 449.172 544.023 449.172 555.156C449.172 566.29 458.226 575.344 469.359 575.344C480.493 575.344 489.547 566.29 489.547 555.156C489.547 544.023 480.493 534.969 469.359 534.969Z",
    fill: "url(#paint27_linear_893_5460)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_893_5460",
    x1: 323,
    y1: 473.563,
    x2: 323,
    y2: 420.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_893_5460",
    x1: 318.73,
    y1: 379.918,
    x2: 317.413,
    y2: 330.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_893_5460",
    x1: 333.72,
    y1: 268.604,
    x2: 328.673,
    y2: 353.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_893_5460",
    x1: 79.4429,
    y1: 769.765,
    x2: 96.6981,
    y2: 603.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_893_5460",
    x1: 174.602,
    y1: 732.175,
    x2: 158.739,
    y2: 868.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_893_5460",
    x1: 566.562,
    y1: 769.765,
    x2: 549.307,
    y2: 603.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_893_5460",
    x1: 471.398,
    y1: 732.175,
    x2: 487.261,
    y2: 868.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_893_5460",
    x1: 469.359,
    y1: 119.444,
    x2: 469.359,
    y2: 365.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_893_5460",
    x1: 171.594,
    y1: 119.444,
    x2: 171.594,
    y2: 365.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_893_5460",
    x1: 347.513,
    y1: 96.7486,
    x2: 361.392,
    y2: 24.8306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_893_5460",
    x1: 317.953,
    y1: -87.0586,
    x2: 317.953,
    y2: 332.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#957E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373638"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_893_5460",
    x1: 329.112,
    y1: 276.765,
    x2: 326.588,
    y2: 314.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_893_5460",
    x1: 256.159,
    y1: 436.56,
    x2: 256.79,
    y2: 352.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_893_5460",
    x1: 387.373,
    y1: 437.302,
    x2: 388.004,
    y2: 353.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_893_5460",
    x1: 255.367,
    y1: 496.285,
    x2: 256.209,
    y2: 384.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_893_5460",
    x1: 386.575,
    y1: 497.273,
    x2: 387.418,
    y2: 385.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_893_5460",
    x1: 206.756,
    y1: 353.448,
    x2: 246.818,
    y2: 345.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CFBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDAD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_893_5460",
    x1: 302.272,
    y1: 800.258,
    x2: 292.285,
    y2: 754.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_893_5460",
    x1: 343.733,
    y1: 800.258,
    x2: 353.72,
    y2: 754.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_893_5460",
    x1: 209.309,
    y1: 640.61,
    x2: 208.168,
    y2: 627.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAEB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_893_5460",
    x1: 184.867,
    y1: 392.102,
    x2: 186.129,
    y2: 402.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_893_5460",
    x1: 184.731,
    y1: 603.954,
    x2: 184.635,
    y2: 602.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_893_5460",
    x1: 213.972,
    y1: 603.954,
    x2: 214.068,
    y2: 602.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_893_5460",
    x1: 421.717,
    y1: 362.496,
    x2: 422.978,
    y2: 372.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_893_5460",
    x1: 219.64,
    y1: 387.757,
    x2: 220.902,
    y2: 397.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_893_5460",
    x1: 520.691,
    y1: 573.37,
    x2: 532.915,
    y2: 577.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56585B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_893_5460",
    x1: 370.688,
    y1: 542.034,
    x2: 410.225,
    y2: 547.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6F73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56585B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_893_5460",
    x1: 370.688,
    y1: 542.034,
    x2: 410.225,
    y2: 547.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAAEB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAvatar);
export default __webpack_public_path__ + "static/media/chat-avatar.097fe4551dee665154b6362ec3a3e220.svg";
export { ForwardRef as ReactComponent };